<template>
  <div class="pedido-processo-listagem">
    <PedidoProcessoIntroducao
      titulo="Pedidos de uniformes"
      descricao="Localize solicitações por funcionário, matrícula ou posto e acompanhe cada etapa da entrega."
      icon="mdi-tshirt-crew-outline"
    />
    <ListagemBase
      nomePlural="PedidoUniformes"
      nomeSingular="PedidoUniforme"
      :headers="headers"
      stringCadastro="Nova_solicitacao"
      :buscaSimplificada="false"
      :pesquisaPeriodo="true"
      :pesquisaNome="true"
      :pesquisaMatricula="true"
      :pesquisaClienteLike="true"
      :pesquisaStatusPedidoUniforme="true"
      :buscaParametrizadaPaginada="true"
      :atualizarLocalAposAcao="true"
      :enableSelection="true"
      :bulkActions="bulkActionsPedidoUniforme"
    >
      <template v-slot:upload> </template>
    </ListagemBase>
  </div>
</template>

<script>
import ListagemBase from "@/components/base/Crud/ListagemBase";
import PedidoProcessoIntroducao from "@/components/recursos/pedido-layout/PedidoProcessoIntroducao";
import DataService from "@/services/recursos/PedidoUniformeDataService";

export default {
  name: "ListagemPedidos",
  components: { ListagemBase, PedidoProcessoIntroducao },
  computed: {
    removerFluxoEntregaSolicitacaoUniformeAtivo() {
      try {
        const parametrizacoes =
          this.$store?.state?.inquilino?.parametrizacoes || [];
        const parametrizacaoExistente = parametrizacoes.find(
          (item) =>
            item && item.tipo === "SOLICITACAOUNIFORMEREMOVERFLUXOENTREGA"
        );

        if (!parametrizacaoExistente) {
          return false;
        }
        return parametrizacaoExistente.ativo !== false;
      } catch (err) {
        return false;
      }
    },
    bulkActionsPedidoUniforme() {
      const actions = [];
      if (!this.removerFluxoEntregaSolicitacaoUniformeAtivo) {
        actions.push(
          {
            value: "separacao",
            text: this.$t("Separar"),
            statuses: ["PENDENTE"],
            serviceMethod: "separacao",
            localStatus: "SEPARACAO",
            successMessage: this.$t("Pedido_separado_com_sucesso"),
            errorMessage: this.$t("Nao_foi_possivel_separar_o_pedido"),
          },
          {
            value: "disponibilizar",
            text: this.$t("Disponibilizar"),
            statuses: ["SEPARACAO"],
            serviceMethod: "disponibilizado",
            localStatus: "DISPONIBILIZADO",
            successMessage: this.$t("Pedido_disponibilizado_com_sucesso"),
            errorMessage: this.$t("Nao_foi_possivel_disponibilizar_o_pedido"),
          },
          {
            value: "retirar",
            text: this.$t("Retirar"),
            statuses: ["DISPONIBILIZADO"],
            serviceMethod: "retirado",
            localStatus: "RETIRADO",
            successMessage: this.$t("Pedido_retirado_com_sucesso"),
            errorMessage: this.$t("Nao_foi_possivel_retirar_o_pedido"),
          }
        );
      }
      actions.push({
        value: "receber",
        text: this.$t("Receber"),
        statuses: this.removerFluxoEntregaSolicitacaoUniformeAtivo
          ? ["PENDENTE", "RETIRADO"]
          : ["RETIRADO"],
        serviceMethod: "recebido",
        localStatus: "RECEBIDO",
        successMessage: this.$t("Pedido_retirado_com_sucesso"),
        errorMessage: this.$t("Nao_foi_possivel_retirar_o_pedido"),
      });
      actions.push({
        value: "substituicaoMassa",
        text: this.$t("Substituicao_em_massa"),
        handler: (pedidos, { service }) => service.substituicaoMassa(pedidos),
        successMessage: this.$t("Pedidos_de_substituicao_criados_com_sucesso"),
        errorMessage: this.$t("Nao_foi_possivel_criar_substituicao_em_massa"),
        confirmTitle: this.$t("Confirma_substituicao_em_massa"),
        confirmMessage: this.$t("Confirma_substituicao_em_massa_mensagem"),
      });

      return actions;
    },
  },
  data() {
    return {
      DataService: DataService,
      headers: [
        { text: this.$t("Status"), value: "statusPedido", sortable: "false" },
        {
          text: this.$t("Data"),
          value: "dataPedido",
          sortable: "false",
        },
        {
          text: this.$t("Matricula"),
          value: "funcionario.matricula",
          sortable: "false",
        },
        {
          text: `${this.$t("Pessoa")} / ${this.$t("Funcionario")}`,
          value: "destinatarioNome",
          sortable: "false",
        },
        {
          text: this.$t("PostoTrabalho"),
          value: "postoTrabalho.descricao",
          sortable: "false",
        },
        {
          text: this.$t("dataSolicitacao"),
          value: "dtInclusao",
          sortable: "false",
        },
        {
          text: this.$t("Solicitante"),
          value: "solicitante.nome",
          sortable: "false",
        },
        {
          text: this.$t("Atividade"),
          value: "actionsPedidoUniforme",
          sortable: "false",
        },
        { text: this.$t("Acoes"), value: "actions", sortable: "false" },
      ],
    };
  },
};
</script>

<style></style>
